import clsx from "clsx";
import { cardClasses } from "../Card";

export const formClassNames = clsx(cardClasses, "flex flex-col md:min-h-[500px] h-full");